import React from 'react';
import useRequest from '@hooks/useRequest';
import { IAuthState } from '@components/AuthProvider';

export interface IAuthRequest {
    user: string,
    pass: string
}

export interface IPasswordChangeRequest {
    currentPass: string,
    newPass: string,
    confirmPass: string
}

export function useAuthService () {
    const _request = useRequest();

    const login = React.useCallback((request: IAuthRequest) => {
        return _request.post<IAuthState>(`Auth/Login`, request)
    }, [_request]);

    const logout = React.useCallback(() => {
        return new Promise<void>((resolve, reject) => resolve());
    }, []);

    const changePassword = React.useCallback((request: IPasswordChangeRequest) => {
        return _request.post(`Auth/ChangePassword`, request);
    }, [_request])

    return React.useMemo(() => ({
        login, logout, changePassword
    }), [login, logout, changePassword]);
}